<template>
  <div>
    <div class="row col-md-12">
      <div class="card card-siak">
        <div class="d-flex justify-content-between align-items-center">
          <div class="title">
            <h1>Edit Daftar Siswa</h1>
          </div>
        </div>

        <KTCodePreview>
          <template v-slot:preview>
            <v-card>
              <v-card-title></v-card-title>
              <b-form>
                <div class="row" style="margin-top: 20px;">
                  <h3>Data Siswa</h3>
                </div>

                <div
                  class="row d-flex justify-content-between align-items-center"
                >
                  <div class="col-lg-6">
                    <b-form-group label="Prodi">
                      <b-form-select
                        id="tambahProdi"
                        v-model="selected"
                        :options="prodiOptions"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group label="NRP">
                      <b-form-input
                        id="tambahNrp"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div
                  class="row d-flex justify-content-between align-items-center"
                >
                  <div class="col-lg-6">
                    <b-form-group label="NISM">
                      <b-form-input
                        id="tambahNism"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group label="NIM">
                      <b-form-input
                        id="tambahNim"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">
                    <b-form-checkbox id="tambahPassportDinas"
                      >Passport Dinas</b-form-checkbox
                    >
                  </div>
                </div>

                <div class="row" style="margin-top: 50px;">
                  <h3>Profil Siswa</h3>
                </div>

                <div
                  class="row d-flex justify-content-between align-items-center"
                >
                  <div class="col-lg-6">
                    <b-form-group label="Nama Siswa">
                      <b-form-input
                        id="tambahNamaSiswa"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group label="Kesatuan">
                      <b-form-input
                        id="tambahKesatuan"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div
                  class="row d-flex justify-content-between align-items-center"
                >
                  <div class="col-lg-6">
                    <b-form-group label="Tahun Akademik">
                      <b-form-input
                        id="tambahTahunAkademik"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group label="Angkatan">
                      <b-form-input
                        id="tambahAngkatan"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div
                  class="row d-flex justify-content-between align-items-center"
                >
                  <div class="col-lg-6">
                    <b-form-group label="Email">
                      <b-form-input
                        id="tambahEmail"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group label="Alamat">
                      <b-form-input
                        id="tambahAlamat"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">
                    <b-form-group label="Foto Siswa :">
                      <b-form-file
                        v-model="file2"
                        class="mt-3"
                        plain
                      ></b-form-file>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6"></div>
                  <div class="col-lg-6" style="display: flex;">
                    <b-button
                      type="submit"
                      variant="primary"
                      style="margin-left: auto;"
                      >Simpan</b-button
                    >
                    <b-button
                      type="reset"
                      variant="danger"
                      class="ml-2"
                      style="margin-left: auto;"
                      >Batal</b-button
                    >
                  </div>
                </div>
              </b-form>
            </v-card>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTCodePreview from "@/view/content/CodePreview.vue";

export default {
  data() {
    return {
      selected: null,
      prodiOptions: [
        { value: "a", text: "Tes 1" },
        { value: "b", text: "Tes 2" },
      ],
    };
  },
  components: {
    KTCodePreview,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Daftar" },
      { title: "Siswa", route: "/students/student-list" },
      { title: "Edit Daftar Siswa" },
    ]);
  },
};
</script>
